// Module
var code = "<ng-form> <kform-builder-option property=\"customClass\"></kform-builder-option> <kform-builder-option property=\"hideLabel\"></kform-builder-option> <ng-form> </ng-form></ng-form>";
// Exports
export default code;